import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';


@Injectable({
  providedIn: 'root'
})
export class UserData {
  favorites: string[] = [];
  HAS_LOGGED_IN = 'hasLoggedIn';
  HAS_SEEN_TUTORIAL = 'hasSeenTutorial';

  constructor(
    public storage: Storage ) {
    this.init()
  }

  async init() {
    await this.storage.create()
  }

  // getAlumno(): Promise<string> {
  //   return this.storage.get('alumno').then((value) => {
  //     // console.log('get alumno:', value)
  //     return value;
  //   });
  // }

  hasFavorite(sessionName: string): boolean {
    return (this.favorites.indexOf(sessionName) > -1);
  }

  addFavorite(sessionName: string): void {
    this.favorites.push(sessionName);
  }

  removeFavorite(sessionName: string): void {
    const index = this.favorites.indexOf(sessionName);
    if (index > -1) {
      this.favorites.splice(index, 1);
    }
  }

  login(username: string,visit: string,name: string,email: string,phone: string): Promise<any> {
    return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
      this.setUsername(username);
      this.setVisit(visit);
      this.setName(name);
      this.setEmail(email);
      this.setPhone(phone);
      console.log(username)
      console.log(visit)
      return window.dispatchEvent(new CustomEvent('user:login'));
    });
  }

  // signup(username: string): Promise<any> {
  //   return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
  //     this.setUsername(username);
  //     return window.dispatchEvent(new CustomEvent('user:signup'));
  //   });
  // }

  logout(): Promise<any> {
    return this.storage.remove(this.HAS_LOGGED_IN).then(() => {
      return this.storage.remove('username'),this.storage.remove('visit'),this.storage.remove('name'),this.storage.remove('email'),this.storage.remove('phone');
    }).then(() => {
      window.dispatchEvent(new CustomEvent('user:logout'));
    });
  }

  setVersion(version: string): Promise<any> {
    return this.storage.set('version', version);
  }

  getVersion(): Promise<string> {
    return this.storage.get('version').then((value) => {
      return value;
    });
  }

  // setTutor(username: string): Promise<any> {
  //   return this.storage.set('tutor', username);
  // }
  //
  // getTutor(): Promise<string> {
  //   return this.storage.get('tutor').then((value) => {
  //     return value;
  //   });
  // }
  //
  // setCiclo(ciclo: string): Promise<any> {
  //   return this.storage.set('ciclo', ciclo);
  // }
  //
  // getCiclo(): Promise<string> {
  //   return this.storage.get('ciclo').then((value) => {
  //     return value;
  //   });
  // }

  setUsername(username: string): Promise<any> {
    return this.storage.set('username', username);
  }

  getUsername(): Promise<string> {
    return this.storage.get('username').then((value) => {
      return value;
    });
  }

  setVisit(visit: string): Promise<any> {
    return this.storage.set('visit', visit);
  }
  getVisit(): Promise<string> {
    return this.storage.get('visit').then((value) => {
      return value;
    });
  }

  setName(name: string): Promise<any> {
    return this.storage.set('name', name);
  }
  getName(): Promise<string> {
    return this.storage.get('name').then((value) => {
      return value;
    });
  }

  setEmail(email: string): Promise<any> {
    return this.storage.set('email', email);
  }
  getEmail(): Promise<string> {
    return this.storage.get('email').then((value) => {
      return value;
    });
  }

  setPhone(phone: string): Promise<any> {
    return this.storage.set('phone', phone);
  }
  getPhone(): Promise<string> {
    return this.storage.get('phone').then((value) => {
      return value;
    });
  }

  isLoggedIn(): Promise<boolean> {
    return this.storage.get(this.HAS_LOGGED_IN).then((value) => {
      return value === true;
    });
  }

  checkHasSeenTutorial(): Promise<string> {
    return this.storage.get(this.HAS_SEEN_TUTORIAL).then((value) => {
      return value;
    });
  }
}
